<template>
    
  <div class="streaming px-3">
    <b-row class="gx-5 align-items-center border">
      <b-col cols="12" class="border border-dark bg-light rounded-top">
        <div class="d-flex justify-content-between">
          <div class="p-1">
            <b-button block class="ml-1 mt-1 p-0 bg-danger" @click="closeMe"><b-icon variant="light" icon="x"/></b-button>
          </div>
          <div class="p-1 justify-content-center align-self-center font-alt text-uppercase h4">{{this.room.name}}</div>
          <div class="p-1">
            <b-button size="sm" variant="link" @click="chat_open=!chat_open">
              <b-icon icon="chat-text-fill" :class="chat_open?'text-success':'text-dark'"></b-icon>
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="pb-2 bg-dark">
        <b-row class="bg-dark border-light mt-1 ml-1 mr-1 justify-content-center">
          <b-col class="pr-0 pl-0" :class="[`${landscape===true && chat_open? 'col-8':'col-12'}`]">
            <div v-if="lang_options.length > 1" class="float-right bg-transparent lang-icon">
              <b-form-select size="md" v-model="lang_selected" :options="lang_options" class="mb-0" @change="changeLang" >
              </b-form-select>
            </div>
            <b-embed
              id="videoPlayer" ref="videoPlayer"
              type="iframe"
              :aspect="landscape===true?'16by9 embed-responsive-16by9':'16by9 embed-responsive-16by9'"
              :src="lang_selected"
              class="p-0"
              allowfullscreen
            ></b-embed>
          </b-col>
          <b-col class="pr-0 pl-0" v-if="chat_open" :class="[`${landscape===true? 'col-4':'col-12'}`]">
            <!-- <ChatRoom /> -->
            <Chat 
              :assistant="$store.getters.assistant" 
              :title="$t('chat.question.title')"
              :subTitle="$t('chat.question.sub_title')"
              icon="question-circle-fill"
              icon_variant="info"
              :icon_font_scale="3"
              :embedded="true"
              :room="room.id"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import ChatRoom from '@/components/ChatRoom/ChatRoom'
import Chat from '@/components/Chat/ChatBox'
import Rating from '@/components/Rating/Rating.vue'

export default Vue.extend({
  name: 'Streaming',
  components: { 
    ChatRoom,
    Chat,
    Rating
  },
  props: {
    urls: { 
      type: Array, 
      required: true,
      default: () => []
    },
    room: {type:Object,required: true, default: () => {}},
    data: {type:Object,required: true, default: () => {}}
  },
  data() {
    return {
      landscape: false,
      chat_open: true,
      trace: {
        key_id: null,
        object_name: null
      },
      lang_selected: null,
      lang_options: [],
    }
  },
  methods: {
    changeLang(item) {
    },
    closeMe() {
      this.$emit('closed')
    },
    switchChatRoom() {
      this.chat_open = !this.chat_open
    },
    addTrace() {
      let loader = this.$loading.show()
      let url = '/sessions/public_add_trace'
      let method = 'post'
      this.$store.dispatch(
        method, 
        {
          'url':url, 
          data: {
            key_id: this.$store.getters.assistant.session_id,
            object_name: this.room.id
          }, 
          headers:{}
        })
        .then((resp) => {
          loader.hide()
          this.trace = resp.data
        })
        .catch(err => {
          loader.hide()
        })
    },
    endTrace() {
      let loader = this.$loading.show()
      let url = '/session_traces/public_trace_finished'
      let method = 'post'
      this.$store.dispatch(
        method, 
        {
          'url':url, 
          data: {
            key_id: this.trace.key_id
          }, 
          headers:{}
        })
        .then((resp) => {
          loader.hide()
        })
        .catch(err => {
          loader.hide()
        })
    },
  },
  beforeMount() {
    this.lang_options = this.urls
    this.lang_selected = this.lang_options[0].value
  },
  beforeDestroy() {
    
  },
  destroyed () {
    if(this.$store.getters.event.demo_mode === 1) this.endTrace()
  },
  computed: {
  },
  mounted() {
    this.$store.commit('set_watching_broadcast', true)
    window.onresize = () => {
      this.landscape = window.innerWidth > window.innerHeight
    }
    this.landscape = window.innerWidth > window.innerHeight
    //document.getElementById('video_bg').play()
    this.addTrace()
  },
  beforeDestroy() { 
    this.$store.commit('set_watching_broadcast', false)
  },
  watch: {
  },
  created () {
    
  },
})
</script>

<style lang="scss" scoped>
@import '../../styles/app';
$width_breadcumb : 100px !default;
$height_breadcumb : 24px !default;
$width_breadcumb-2o : $width_breadcumb * 3 !default;

.streaming {

  .overlay:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($dark, .8);
  }

  .container-fluid {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    //justify-content: center;
    //align-items: center;
    //text-align: center;
    //padding: 0 15px;
    //margin-top: $navbar-height*.5;
    
    @include media-breakpoint-down(xs) {
      top: $navbar-height*.5 !important;
    }
    @include media-breakpoint-up(sm) {
      top: $navbar-height*.8 !important;
    }
    @include media-breakpoint-up(lg) {
      top: $navbar-height*.9 !important;
    }
  }
  
  .breadcrumb {
    background-color: var(--$primary);
    text-align: center;
    font-weight: bolder;
    width: $width_breadcumb;
    height: $height_breadcumb;
    display: inline-block;
  }

  .breadcrumb-2o {
    color: var(--$primary);
    background-color: transparent;
    text-align: left;
    font-weight: bolder;
    width: $width_breadcumb-2o;
    height: $height_breadcumb;
    display: inline-block;
  }

}

</style>